module.exports = __webpack_public_path__ + "img/微笑.4a093b24.png";